// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import AddSubscriptionRequestModel from '../../model/add-subscription-request-model';
import AddSubscriptionRequestDTO from '../dto/add-subscription-request-dto';
import dtoSchema from '../schemas/add-subscription-request-schema';
import ContactModel from '../../model/contact-model';
import DeliveryAddressModel from '../../model/delivery-address-model';
import BasketModel from '../../model/basket-model';
import RequestSummaryModel from '../../model/request-summary-model';

export default abstract class AddSubscriptionRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<AddSubscriptionRequestDTO>) {
    super();
    if (data) {
      this.userId = data.userId;
      this.subscriptionType = data.subscriptionType;
      this.subscriptionTemplateNumber = data.subscriptionTemplateNumber;
      this.entryDate = data.entryDate ?? undefined;
      this.isBillingContactReadonly = data.isBillingContactReadonly;
      this.billingContact = data.billingContact ? ContactModel.toModel(data.billingContact) : undefined;
      this.isDeliveryContactReadonly = data.isDeliveryContactReadonly;
      this.deliveryContact = data.deliveryContact ? DeliveryAddressModel.toModel(data.deliveryContact) : undefined;
      this.orderBasket = data.orderBasket ? BasketModel.toModel(data.orderBasket) : undefined;
      this.summary = data.summary ? RequestSummaryModel.toModel(data.summary) : undefined;
      this.newsletter = data.newsletter;
      this.languageIso2 = data.languageIso2 ?? undefined;
      this.acceptGdpr = data.acceptGdpr;
      this.acceptAgb = data.acceptAgb;
    }
  }
  /**
  * @type {int64}
  */
  userId?: number;
  /**
  * @type {int32}
  */
  subscriptionType?: 1 | 2; // SubscriptionTypeDTO
  /**
  * @type {int32}
  */
  subscriptionTemplateNumber?: number;
  /**
  * @type {date-time}
  */
  entryDate?: string;
  /**
  */
  isBillingContactReadonly?: boolean;
  /**
  */
  billingContact?: ContactModel;
  /**
  */
  isDeliveryContactReadonly?: boolean;
  /**
  */
  deliveryContact?: DeliveryAddressModel;
  /**
  */
  orderBasket?: BasketModel;
  /**
  */
  summary?: RequestSummaryModel;
  /**
  */
  newsletter?: boolean;
  /**
  */
  languageIso2?: string;
  /**
  */
  acceptGdpr?: boolean;
  /**
  */
  acceptAgb?: boolean;

  static toModel(dto: DeepPartial<AddSubscriptionRequestDTO>): AddSubscriptionRequestModel;
  static toModel(dto: DeepPartial<AddSubscriptionRequestDTO> | undefined | null): AddSubscriptionRequestModel | undefined;
  static toModel(dto: DeepPartial<AddSubscriptionRequestDTO> | undefined | null): AddSubscriptionRequestModel | undefined {
    return dto ? new AddSubscriptionRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<AddSubscriptionRequestModel> | AddSubscriptionRequestModel): AddSubscriptionRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      userId: unwrapped.userId,
      subscriptionType: unwrapped.subscriptionType,
      subscriptionTemplateNumber: unwrapped.subscriptionTemplateNumber,
      entryDate: unwrapped.entryDate,
      isBillingContactReadonly: unwrapped.isBillingContactReadonly,
      billingContact: unwrapped.billingContact,
      isDeliveryContactReadonly: unwrapped.isDeliveryContactReadonly,
      deliveryContact: unwrapped.deliveryContact,
      orderBasket: unwrapped.orderBasket,
      summary: unwrapped.summary,
      newsletter: unwrapped.newsletter,
      languageIso2: unwrapped.languageIso2,
      acceptGdpr: unwrapped.acceptGdpr,
      acceptAgb: unwrapped.acceptAgb,
    } as AddSubscriptionRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for AddSubscriptionRequestModel, can not map to AddSubscriptionRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
